<!-- https://xd.adobe.com/view/0b9dc836-c0b3-4d58-817e-af7cee22af11-5ece/
https://xd.adobe.com/view/0b9dc836-c0b3-4d58-817e-af7cee22af11-5ece/screen/712d5a7f-bfbb-42ff-a118-784b083849fa/specs/ 
https://docs.google.com/document/d/1JOy1cSFY-KGBVHjjZMcWkEtaLlliAzMHHh6ceHp8gBo/edit
-->
<template>
  <div id="anbefalktohomeowners" class="clearfix px2">
      <div class="mt2 pointer">
          <i class="el-icon-back h4" @click="gotomenikunder()"></i>
      </div>
      <div class="notosans">
            <p class="h1 darkblue col-12 center line-height-golden mt3 bold ">Tak fordi du giver din anbefaling</p>
            <p class="h5 darkblue col-12 center line-height-golden">Din anbefaling er med til at sikre, at fremtidige kunder trygt og sikkert kan vælge den rigtige håndværker til at løse deres opgave.
                Vi vil meget gerne blive klogere på, hvordan din oplevelse har været og hvordan du vil vurdere håndværkeren.</p>
      </div>
      <form-wizard ref="anbefalhomeowners" title="" subtitle="" shape="circle" color="rgba(25, 163, 192, 1.0)" error-color="rgba(207,0,15,1.0)" finishButtonText="Bekræft">
        <tab-content title="1 ud af 4" >
          <div class="notosans">
                <div>
                  <el-form id="cvrfrom"  class="md-col-11 lg-col-11 sm-col-12 mx-auto darkblue"  ref="mainanbefalform" label-position="top">
                  <div class="flex flex-column mt2 max-width-5 mx-auto px4 py3 border primarycolor-border">
                      <div class="mb2 p0 mp0 flex">
                        <div class="flex flex-column mr-auto">
                          <label class="semi-bold h5 m0">Kommunikation</label>
                          <span class="" style="font-size:11px">Svarprocent for kommunikation. - Er boligejer lydhør over for dialoger med håndværkeren, for at de kan afslutte deres projekt korrekt?</span>
                        </div>
                        <div class="ml-auto">
                          <image-rating src='/static/svg/single-house.svg' :max-rating="5" :increment="1" :item-size="30" :spacing="4" v-model="anbefalform.Kommunikation"></image-rating>
                        </div>
                      </div>
                      <div class="mb2 p0 flex col-12 ">
                        <div class="flex flex-column mr-auto ">
                          <label class="semi-bold h5 m0">Overholdte Tidplanerne</label>
                          <span style="font-size:11px">Aktualitet for møder og tidsplan. - Overholdt husejeren planlagte møder vedrørende projektet?</span>
                        </div>
                        <div class="ml-auto">
                          <image-rating src='/static/svg/single-house.svg' :max-rating="5" :increment="1" :item-size="30" :spacing="4" v-model="anbefalform.Overholdte"></image-rating>
                        </div>
                      </div>
                      <div class="mb2 p0 mp0 flex col-12 ">
                        <div class="flex flex-column mr-auto ">
                          <label class="semi-bold h5 m0">Realistike forventninger</label>
                          <span class="" style="font-size:11px">Forventninger: Opgav husejeren ærlige og realistiske projektdetaljer og deadlines?</span>
                        </div>
                        <div class="ml-auto">
                          <image-rating src='/static/svg/single-house.svg' :max-rating="5" :increment="1" :item-size="30" :spacing="4" v-model="anbefalform.Realistike"></image-rating>
                        </div>
                      </div>
                      <div class="mb2 p0 flex col-12 ">
                        <div class="flex flex-column mr-auto ">
                          <label class="semi-bold h5 m0">Samarbejdsvillighed</label>
                          <span class="" style="font-size:11px">Var husejeren nem at arbejde med?</span>
                        </div>
                        <div class="ml-auto">
                          <image-rating src='/static/svg/single-house.svg' :max-rating="5" :increment="1" :item-size="30" :spacing="4" v-model="anbefalform.Samarbejdsvillighed"></image-rating>
                        </div>
                      </div>
                      <div class="mb2 p0 mp0 flex col-12 ">
                        <div class="flex flex-column mr-auto ">
                          <label class="semi-bold h5 m0">Økomonisk sikkerhed </label>
                          <span class="" style="font-size:11px">Var husejeren i stand til at betale til tiden for deres projekter, eller satte husejeren et realistisk budget?</span>
                        </div>
                        <div class="ml-auto">
                          <image-rating src='/static/svg/single-house.svg' :max-rating="5" :increment="1" :item-size="30" :spacing="4" v-model="anbefalform.sikkerhed"></image-rating>
                        </div>
                      </div>
                      <div class="mb2 p0 flex col-12 ">
                        <div class="flex flex-column mr-auto ">
                          <label class="semi-bold h5 m0">Adgang til arbejdet</label>
                          <span class="" style="font-size:11px">var der plads til at kunne udføre arbejdet</span>
                        </div>
                        <div class="ml-auto">
                          <image-rating src='/static/svg/single-house.svg' :max-rating="5" :increment="1" :item-size="30" :spacing="4" v-model="anbefalform.Adgang"></image-rating>
                        </div>
                      </div>
                    <el-alert v-if="norateerror" title="Udfyld venligst en af ​​satserne" type="error" :closable="false" show-icon></el-alert>
                  </div>
                    <div class="mt3 p0 flex col-12 border primarycolor-border px4 py3 ">
                        <div class="flex flex-column mr-auto">
                          <label class="semi-bold h4">Din samlede vurdering</label>
                        </div>
                        <div class="ml-auto">
                          <image-rating src='/static/svg/single-house.svg' :max-rating="5" :read-only="true" :increment="0.5" :item-size="40" :spacing="4" v-model="TotalGrade"></image-rating>
                        </div>
                    </div>
                    <div class="flex mobile-flex-column my3 ">
                    <!-- <button type="button" @click="backstep()" class="mt2 not-rounded md-col-4 lg-col-4 sm-col-12 outlined-primary-button h5 regular no-hover mr-auto p2 px4 line-height0 mb1"> <i class="el-icon-back pr1"></i>Tilbage
                    </button> -->
                    <button type="button" @click="nextStep()" class="mt2 not-rounded md-col-4 lg-col-4 sm-col-12 action-button h5 regular no-hover ml-auto p2 px4 line-height0 mb1">Næste <i class="pl1 el-icon-right"></i>
                    </button>
                  </div>
              </el-form>
              </div>
          </div>
        </tab-content>
        <tab-content title="2 ud af 2" >
            <div class="highlights max-width-2 mx-auto">
                    <el-form id="cvrfrom" :model="step2form" class="max-with-4 sm-col-12 mx-auto p3" ref="rulesstep2forms" :rules="rulesstep2form" label-position="top">
                    <div class="flex flex-row mobile-flex-column">
                      <div class="m0 p0 lg-col-12 md-col-12 sm-col-12">
                      <el-form-item label="Title" id="Firmanavn" prop="headline" class="border-none">
                          <el-input v-model="step2form.headline"  class="border wizard-border white-background" placeholder="Giv din anbefaling en titel. fx Nyt tag"></el-input>
                      </el-form-item>
                      </div>
                    </div>
                    <div class="flex flex-row mobile-flex-column">
                      <div class="m0 p0 mp0 lg-col-12 md-col-12 sm-col-12">
                        <el-form-item id="comment" label="Kommentar" prop="comment" class="border-none p0 ">
                            <el-input v-model="step2form.comment" type="textarea" class="border wizard-border white-background" placeholder="Beskriv hvad du har fået lavet og hvordan du oplevede vores arbejde og service."></el-input>
                        </el-form-item>
                        </div>
                    </div>
                    <div class="flex mobile-flex-column my2 ">
                      <button @click="backstep()" type="button" class="mt2 not-rounded md-col-5 lg-col-5 sm-col-12 action-button h5 regular no-hover mr-auto p2 px4 line-height0 mb1"><i class="pr1 el-icon-back"></i> Tilbage
                      </button>
                      <button @click="savereview()" type="button" class="mt2 not-rounded md-col-5 lg-col-5 sm-col-12 action-button h5 regular no-hover ml-auto p2 px4 line-height0 mb1">Bekræft <i class="pl1 el-icon-right"></i>
                      </button>
                    </div>
                </el-form>
          </div>
        </tab-content>
        <div class="py4"></div>
      </form-wizard>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>

import Simplert from 'vue2-simplert'
import VueFormWizard from 'vue-form-wizard'
import vSelect from 'vue-select'
import StarRating from 'vue-star-rating'
import {ImageRating} from 'vue-rate-it'
export default {
  name: 'AnbefaltoHomeowners',
  components: {
    Simplert,
    vSelect,
    VueFormWizard,
    StarRating,
    ImageRating
  },
  computed: {
  },
  data: function () {
    return {
      loading: false,
      anbefalform: {
        Kommunikation: 0,
        Overholdte: 0,
        Realistike: 0,
        Samarbejdsvillighed: 0,
        sikkerhed: 0,
        Adgang: 0
      },
      TotalGrade: 0,
      step2form: {
        headline: '',
        comment: ''
      },
      rulesstep2form: {
        headline: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit overskrift',
          trigger: 'blur'
        }],
        comment: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste en kommentar',
          trigger: 'blur'
        }]
      },
      haaid: '',
      salesPerson: '',
      customerID: '',
      norateerror: false
    }
  },
  watch: {
    'anbefalform.Kommunikation': function (newVal, oldVal) {
      this.updateGrade()
    },
    'anbefalform.Overholdte': function (newVal, oldVal) {
      this.updateGrade()
    },
    'anbefalform.Realistike': function (newVal, oldVal) {
      this.updateGrade()
    },
    'anbefalform.Samarbejdsvillighed': function (newVal, oldVal) {
      this.updateGrade()
    },
    'anbefalform.sikkerhed': function (newVal, oldVal) {
      this.updateGrade()
    },
    'anbefalform.Adgang': function (newVal, oldVal) {
      this.updateGrade()
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    if (screen.width >= 1000) {
      this.showXXL = true
    } else {
      this.showXXL = false
    }
    this.customerID = this.$route.query.cid
  },
  methods: {
    nextStep () {
      if (this.TotalGrade === 0 && this.$refs.anbefalhomeowners.activeTabIndex === 0) {
        this.norateerror = true
        return false
      }
      this.$refs.anbefalhomeowners.nextTab()
    },
    backstep () {
      this.$refs.anbefalhomeowners.prevTab()
    },
    updateGrade () {
      this.norateerror = false
      this.TotalGrade = this.roundToTwo((this.anbefalform.Kommunikation + this.anbefalform.Overholdte + this.anbefalform.Realistike + this.anbefalform.Samarbejdsvillighed + this.anbefalform.sikkerhed + this.anbefalform.Adgang) / 6)
    },
    roundToTwo (num) {
      return Math.round(num * 10) / 10
    },
    gotomenikunder () {
      this.$router.push('/alle-moeder')
    },
    savereview () {
      var error = 0
      this.$refs['rulesstep2forms'].validate((valid) => {
        if (!valid) {
          error = 1
        }
      })
      if (error === 1 && this.customerID !== '') { return }
      this.$confirm('Indsende denne anmeldelse?', {
        confirmButtonText: 'Indsend',
        cancelButtonText: 'Annuller',
        type: 'warning'
      }).then(() => {
        this.haaid = localStorage.getItem('haaid')
        this.salesPerson = localStorage.getItem('id_token_portalbitrix')
        var headers = {
          Authorization: 'Bearer ' + this.salesPerson
        }
        var data = {
          UF_HEADLINE: this.step2form.headline,
          UF_COMMENT: this.step2form.comment,
          UF_ENTERPRISE_SUM: 0,
          UF_CUSTOMER_ID: parseInt(this.customerID),
          UF_RATING_COMMUNICATION: this.anbefalform.Kommunikation,
          UF_RATING_TIME: this.anbefalform.Overholdte,
          UF_RATING_ACCESS: this.anbefalform.Adgang,
          UF_RATING_REALISTIC_EXPECTATIONS: this.anbefalform.Realistike,
          UF_RATING_FINANCIAL_SECURITY: this.anbefalform.sikkerhed,
          UF_RATING_COLLABORATION: this.anbefalform.Samarbejdsvillighed
        }
        this.$http.post(this.$bitrixapi + 'partner/SavePartnerReviewonHomeowner', data, {headers}, { emulateJSON: true }).then(
          (response) => {
            var res = response.body
            if (res.success) {
              this.$router.push('/anbefalinger-sammendrag')
            }
          },
          (response) => {
            console.log('Error: ', response)
          }
        )
      }).catch(() => {
        if (this.editingdraft === 0) {
          this.addglow()
        } else if (this.editingdraft === 1) {
          this.updatetilbud()
        }
      })
    }
  }
}
</script>
<style>
  #anbefalktohomeowners  .vue-form-wizard {
      padding-bottom: 2rem;
      margin-bottom: 2rem;
  }
  #anbefalktohomeowners .vs__dropdown-toggle {
    border:0;
    background: rgba(230, 234, 235, 0.5);
    width:100%;
  }
  #anbefalktohomeowners .wizard-card-footer {
    display: none;
  }
  #anbefalktohomeowners .primarycolor-border {
      border-color: #19A3C080!important;
  }
  #anbefalktohomeowners .wizard-progress-with-circle {
    display: inherit;
  }
  #anbefalktohomeowners .vue-form-wizard .wizard-nav-pills {
      display: flex;
      width: 80%;
      margin-left: auto;
      margin-right: auto;
  }
  #anbefalktohomeowners .vue-form-wizard.md .wizard-icon-circle {
    width: 40px;
    height: 40px;
    font-size: 14px;
  }
  #comment .el-textarea__inner{
    min-height: 102px!important;
  }
  #anbefalktohomeowners .vue-form-wizard.md .wizard-navigation .wizard-progress-with-circle {
      top: 24px;
      height: 4px;
      width: 80%;
      margin-left: auto;
      margin-right: auto;
  }
  #anbefalktohomeowners .wizard-footer-left .wizard-btn {
    display: none;
    border: 1px solid rgba(178,190,195, 0.5)!important;
    color: rgba(178,190,195, 0.5)!important;
    background-color: #00968808!important;
    padding: 1rem!important;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0;
    font-family: 'canada-type-notosans';
    font-weight: 600!important;
  }
  #anbefalktohomeowners .vue-form-wizard .wizard-card-footer .wizard-footer-left {
    display: none;
  }
  #anbefalktohomeowners .wizard-footer-left .wizard-btn:hover {
      background: rgba(178,190,195, 0.5);
      color: white;
      display: none;
    }
  #anbefalktohomeowners  .wizard-footer-right .wizard-btn {
    display: none;
    background: rgba(77, 207, 85, 1.0)!important;
    background-color: rgba(77, 207, 85, 1.0)!important;
    color: #fff;
    padding: 1rem!important;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0;
    font-family: 'canada-type-notosans';
    font-weight: 600!important;
  }
  #anbefalktohomeowners .wizard-icon-circle.checked {
    background: rgb(25, 163, 192)!important;
    color: #fff
  }
  #anbefalktohomeowners .vue-form-wizard .wizard-icon-circle {
    font-size: 12px;
    font-weight: 500;
  }
  #anbefalktohomeowners  .wizard-nav .stepTitle {
    display: none;
    width:100%;
    color: lighten(#5a5a5a, 40%);
    background-color: #fff;
    border-bottom: 3px solid lighten(#5a5a5a, 60%);
    padding: 1rem .25rem 0.5rem 1rem;
    text-align: left;
    font-weight:400;
    font-size: 13.5px;
  }
  #anbefalktohomeowners  .wizard-nav .stepTitle.active {
    background-color: #fff;
    color: lighten(#5a5a5a, 40%)!important;
    border-bottom: 3px solid rgba(77, 207, 85, 1.0);
  }
  #anbefalktohomeowners  .wizard-nav .stepTitle::after {
    height: 0;
  }
  #anbefalktohomeowners  .wizard-nav .checked + .stepTitle {
    color: rgba(77, 207, 85, 1.0);
    border-bottom: 3px solid rgba(77, 207, 85, 1.0);
  }
</style>



// WEBPACK FOOTER //
// anbefalktohomeowners.vue?a45c871e